import dayjs, { Dayjs } from "dayjs"
// require("dayjs/locale/bn")
// dayjs.locale("bn")
import customParseFormat from "dayjs/plugin/customParseFormat"
// import "dayjs/locale/bn" // Import Bengali locale

import "dayjs/locale/en" // Import French locale

dayjs.locale("en") // Set globally

export const DATE_FORMAT = "DD/MM/YYYY"
const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm"

export const formatDate = (
  timestamp?: number,
  format: string = DATE_FORMAT
): string => {
  if (timestamp) {
    return dayjs(timestamp).format(format)
  } else {
    return dayjs().format(format)
  }
}

export const formatDateTime = (timestamp?: number): string => {
  return formatDate(timestamp, DATE_TIME_FORMAT)
}

export const getDayJSObjectFromString = (
  date: string,
  format: string = DATE_TIME_FORMAT
): Dayjs => {
  // console.log(date)
  if (date) {
    return dayjs(date, format)
  } else {
    return dayjs()
  }
}

/**
 *
 * @param date previously, it was saved as long (timestamp) -- which should be a string
 * @returns
 */
export const fixInvoiceDate = (date: string | number): string => {
  return typeof date === "string" ? date : formatDate(date, DATE_TIME_FORMAT)
}
